import { render } from "./NonMedicarePayorNew.vue?vue&type=template&id=6919fbf3&ts=true"
import script from "./NonMedicarePayorNew.ts?vue&type=script&lang=ts&external"
export * from "./NonMedicarePayorNew.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__